'use client';
/** @jsxImportSource @emotion/react */

import type { CardHeaderProps as MuiCardHeaderProps } from '@mui/material/CardHeader';

import MuiCardHeader from '@mui/material/CardHeader';

type ExcludedMuiProps = 'disableTypography';
interface CardHeaderProps extends Omit<MuiCardHeaderProps, ExcludedMuiProps> {
  component?: React.ElementType;
}
export type { CardHeaderProps };
export const CardHeader = MuiCardHeader;
